import { render, staticRenderFns } from "./SliderMultigame.vue?vue&type=template&id=093246e0&"
import script from "./SliderMultigame.vue?vue&type=script&lang=js&"
export * from "./SliderMultigame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports